import React from 'react';
import axios from 'axios';
import moment from 'moment'
import formatNumber from 'accounting-js/lib/formatNumber.js';

import SemillasReceptionsModal from './SemillasReceptionsModal';
import SemillasReceptionsModalReport from './SemillasReceptionsModalReport';
import Parrilla from '../../Components/Parrilla/Parrilla';

class SemillasReceptionsPage extends React.Component {

	state = {
		rows: [],
		page: 1,
		nextPage: null,
		prevPage: null,
		lastPage: null,
		sort: 'SemillasReceptions.date',
		direction: 'DESC',
		field: null,
		query: null,
		modalOpened: false,
		modalId: '',
		modalReport: false
	}

	async componentDidMount() {
		const self = this;

		// Execute initial actions
		await self.loadParrillaData();
	}

	async loadParrillaData() {
		const self = this;

		// Auth Headers
		let authHeaders = await window.prepareAuthHeaders();

		// Get token from python
		await axios.get(
			window.API_URL + '/semillasreceptions/list',
			{	
				params: {
					page: self.state.page,
					sort: self.state.sort,
					direction: self.state.direction,
					field: self.state.field,
					query: self.state.query
				},
				headers: authHeaders
			}
		).then((response) => {
			self.setState((state) => {
				if ( response.data ) {
					state.rows = response.data.rows;
					state.page = response.data.page;
					state.nextPage = response.data.nextPage;
					state.prevPage = response.data.prevPage;
					state.lastPage = response.data.lastPage;
				}
				return state;
			});
		});
	}

	parrillaSortCallback(key) {
		const self = this;

		// Update State
		self.state.sort = key;
		self.state.direction = self.state.direction === 'asc' ? 'desc' : 'asc';

		// Reload data
		self.loadParrillaData();
	}

	parrillaChangePageCallback(page) {
		const self = this;

		// Set page
		self.state.page = page;

		// Reload data
		self.loadParrillaData();
	}

	parrillaSearchCallback(field, query) {
		const self = this;

		// Set page
		self.state.field = field;
		self.state.query = query;

		// Reload data
		self.loadParrillaData();
	}

	openModal(event, idx = null) {
		const self = this;

		// Prevent
		if ( event ) event.preventDefault();

		// Set modal opened
		self.setState((state) => {
			state.modalOpened = true;
			state.modalId = idx !== null ? self.state.rows[idx].id : null;
			return state;
		});
	}

	openModalReport(event) {
		const self = this;

		// Prevent
		if ( event ) event.preventDefault();

		// Set modal opened
		self.setState((state) => {
			state.modalReport = true;
			return state;
		});
	}

	closeModal() {
		const self = this;

		// Set modal opened
		self.setState((state) => {
			state.modalOpened = false;
			state.modalId = '';
			return state;
		});

		// Reload parrilla
		self.loadParrillaData();
	}

	closeModalReport() {
		const self = this;

		// Set modal opened
		self.setState((state) => {
			state.modalReport = false;
			return state;
		});
	}

	render() {
		const self = this;

		// Prepare header
		let header = [
			{ text: 'Agricultor', key: 'Farmers.name', width: 200 },
			{ text: 'Fecha', key: 'SemillasReceptions.date', width: 100 },
			{ text: 'Ticket', key: 'SemillasReceptions.number', width: 100 },
			{ text: 'Semilla', key: 'Articles.description', width: 100 },
			{ text: 'Toneladas', key: 'SemillasReceptions.origin_net', width: 100 },
			{ text: 'Royalty', key: 'SemillasReceptions.royalty_calc', width: 100 },
			{ text: 'Estado', key: 'SemillasReceptions.status', width: 10, align: 'center' },
		];

		// Prepare rows
		let rows = [];
		if ( self.state.rows ) self.state.rows.forEach((el, idx) => {
			let tmpRow = [];
			tmpRow.push(
				{text: el.farmer ? el.farmer.name : '', align: 'left'},
				{text: moment(el.date).format('DD-MM-Y'), align: 'right'},
				{text: el.number, align: 'right'},
				{text: el.article ? el.article.description : '', align: 'left'},
				{text: formatNumber(el.origin_net, {precision: 3, thousand: ".", decimal: ","}), align: 'right'},
				{text: formatNumber(el.royalty_fix ?? 0, {precision: 2, thousand: ".", decimal: ","}), align: 'right'},
				{
					text: (() => {
						let colorClass = "danger";
						if ( el.status === 1 ) colorClass = "info";
						if ( el.status === 2 ) colorClass = "warning";
						if ( el.status === 3 ) colorClass = "success";
						return <span className={"btn btn-sm btn-" + colorClass}><i className={"fa fa-bullseye"}></i></span>
					})(), 
					align: 'center'
				},
			);
			rows.push(tmpRow);
		});

		// Prepare searchFields
		let searchFields = [
			{ text: 'Ticket', key: 'SemillasReceptions.number' },
			{ text: 'Agricultor', key: 'Farmers.name' },
			{ text: 'Semilla', key: 'Articles.description' },
			{ text: 'Fecha', key: 'SemillasReceptions.date' },
		];

		// Render
		return (
			<React.Fragment>
				<Parrilla 
					title="50.0 Recepción Semillas"

					header={header} 
					rows={rows} 

					sortCallback={(key) => self.parrillaSortCallback(key)}
					clickRowCallback={(idx) => self.openModal(null, idx)}

					paginator={{page: self.state.page, prevPage: self.state.prevPage, nextPage: self.state.nextPage, lastPage: self.state.lastPage}}
					pageChangeCallback={(page) => self.parrillaChangePageCallback(page)}

					btnAdd={true}
					btnAddCallback={(event) => self.openModal(event)}

					btnSearch={true}
					searchFields={searchFields}
					clickSearchCallback={(field, query) => self.parrillaSearchCallback(field, query)}

					btnsCustom={
						<button onClick={() => self.openModalReport()} className="btn btn-default"><i className='fa fa-print'></i></button>
					}
				></Parrilla>

				{ self.state.modalOpened === true &&
					<SemillasReceptionsModal 
						id={self.state.modalId}
						close={() => self.closeModal()}
					/>
				}
				{ self.state.modalReport === true &&
					<SemillasReceptionsModalReport 
						close={() => self.closeModalReport()}
					/>
				}
			</React.Fragment>
		);
	}
}

export default SemillasReceptionsPage;
